export enum QuestionnaireAnswerType {
  STRING = 'string',
  BOOLEAN = 'boolean',
  DATE = 'date',
  DATE_TIME = 'dateTime',
  TIME = 'time',
  DECIMAL = 'decimal',
  INTEGER = 'integer',
  CODING = 'coding',
  REFERENCE = 'reference',
  GROUP = 'group'
}

export const NUMBER_QUESTIONNAIRE_ITEM_TYPES = [
  QuestionnaireAnswerType.DECIMAL,
  QuestionnaireAnswerType.INTEGER
]
